export class LoginModel {
    public userName: string;
    public password: string;
}
